import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styled from 'styled-components';

import HeaderNotification, {
  NOTIFICATION_TYPES,
} from '@components/HeaderNotification';
import { willOpenLater, isClosed, willOpenLaterCanPreOrder } from '@utils/shop';

import messages from './messages';

const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.elementLine};
  background-color: ${({ theme }) => theme.colors.white};
`;

function Notification({
  shop,
  weeklyDiscount,
  showDiscount,
  intl: { formatMessage },
}) {
  const discountAmount = useMemo(
    () => weeklyDiscount?.amount || shop?.discount,
    [shop, weeklyDiscount],
  );
  const notifications = [];
  if (isClosed(shop) && !shop?.closedReason) {
    notifications.push({
      text: formatMessage(messages.shop_is_closed),
      label: formatMessage(messages.shop_no_preOrder_label),
      type: NOTIFICATION_TYPES.CLOSED,
    });
  } else if (isClosed(shop) && shop?.closedReason) {
    notifications.push({
      text: formatMessage(messages.shop_is_closed_reason),
      type: NOTIFICATION_TYPES.CLOSED_REASON,
    });
  } else {
    if (showDiscount && discountAmount) {
      notifications.push({
        text: formatMessage(messages.shop_discount, {
          discount: discountAmount,
        }),
        label: formatMessage(messages.shop_discount_label),
        type: NOTIFICATION_TYPES.DISCOUNT,
      });
    }

    if (willOpenLater(shop)) {
      notifications.push({
        text: formatMessage(messages.shop_opens_in),
        nextHour: shop.nextHour,
        label: willOpenLaterCanPreOrder(shop)
          ? formatMessage(messages.shop_preOrder_label)
          : formatMessage(messages.shop_no_preOrder_label),
        type: NOTIFICATION_TYPES.OPEN_IN,
      });
    }
  }
  if (!notifications.length) return null;

  const content = notifications.map((x, idx) => (
    <HeaderNotification
      key={x.label}
      isLast={idx === notifications.length - 1}
      {...x}
    />
  ));

  return <Container>{content}</Container>;
}

Notification.propTypes = {
  shop: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  weeklyDiscount: PropTypes.shape,
  showDiscount: PropTypes.bool,
};

Notification.defaultProps = {
  showDiscount: true,
};

export default injectIntl(memo(Notification));
